var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        { staticClass: "pt-2" },
        [
          _vm.gpcSession
            ? _c(
                "b-container",
                { staticClass: "pt-0 pb-0 " },
                [
                  _c("customer-selection", {
                    ref: "customerfield",
                    attrs: {
                      customer: _vm.gpcSession.customer_id,
                      noNew: true
                    },
                    on: {
                      "update:customer": function($event) {
                        _vm.gpcSession.customer_id = $event
                      }
                    },
                    model: {
                      value: _vm.gpcSession.customer_id,
                      callback: function($$v) {
                        _vm.$set(_vm.gpcSession, "customer_id", $$v)
                      },
                      expression: "gpcSession.customer_id"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "dateOfSessionGroup",
                                breakpoint: "md",
                                label: "Date of Session",
                                "label-for": "date",
                                validated: ""
                              }
                            },
                            [
                              _c("datepicker", {
                                attrs: {
                                  id: "date",
                                  disabledDates: { from: new Date() }
                                },
                                model: {
                                  value: _vm.gpcSession.session_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.gpcSession,
                                      "session_date",
                                      $$v
                                    )
                                  },
                                  expression: "gpcSession.session_date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "problemOwnerGroup",
                                breakpoint: "md",
                                label: "Problem Owner and Title",
                                "label-for": "problemOwner",
                                validated: ""
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: "Name",
                                  id: "problemOwner",
                                  required: ""
                                },
                                model: {
                                  value: _vm.gpcSession.responsible_name,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.gpcSession,
                                      "responsible_name",
                                      $$v
                                    )
                                  },
                                  expression: "gpcSession.responsible_name"
                                }
                              }),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: "Title/Role",
                                  id: "problemOwnerRole",
                                  required: ""
                                },
                                model: {
                                  value: _vm.gpcSession.responsible_role,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.gpcSession,
                                      "responsible_role",
                                      $$v
                                    )
                                  },
                                  expression: "gpcSession.responsible_role"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "coachGroup",
                                breakpoint: "md",
                                label: "Coach",
                                "label-for": "coach",
                                validated: ""
                              }
                            },
                            [
                              _c("b-form-select", {
                                staticClass: "mb-3",
                                attrs: {
                                  options: [
                                    "Jenni Ross-Janett",
                                    "Kelly McLuckie"
                                  ],
                                  id: "coach",
                                  required: ""
                                },
                                model: {
                                  value: _vm.gpcSession.coach_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.gpcSession, "coach_name", $$v)
                                  },
                                  expression: "gpcSession.coach_name"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "participantsGroup",
                                breakpoint: "md",
                                label: "Group Members",
                                "label-for": "participants",
                                validated: ""
                              }
                            },
                            [
                              _c("wysiwyg", {
                                attrs: { id: "participants" },
                                model: {
                                  value: _vm.gpcSession.participants,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.gpcSession,
                                      "participants",
                                      $$v
                                    )
                                  },
                                  expression: "gpcSession.participants"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "problemGroup",
                                breakpoint: "md",
                                label: "Problem",
                                "label-for": "problem",
                                validated: ""
                              }
                            },
                            [
                              _c("wysiwyg", {
                                attrs: { id: "problem" },
                                model: {
                                  value: _vm.gpcSession.problem,
                                  callback: function($$v) {
                                    _vm.$set(_vm.gpcSession, "problem", $$v)
                                  },
                                  expression: "gpcSession.problem"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "actionsGroup",
                                breakpoint: "md",
                                label: "Actions",
                                "label-for": "actions",
                                validated: ""
                              }
                            },
                            [
                              _c("wysiwyg", {
                                attrs: { id: "actions" },
                                model: {
                                  value: _vm.gpcSession.actions,
                                  callback: function($$v) {
                                    _vm.$set(_vm.gpcSession, "actions", $$v)
                                  },
                                  expression: "gpcSession.actions"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "nextStepGroup",
                                breakpoint: "md",
                                label: "Next Step",
                                "label-for": "next_step",
                                validated: ""
                              }
                            },
                            [
                              _c("wysiwyg", {
                                attrs: { id: "next_step" },
                                model: {
                                  value: _vm.gpcSession.next_step,
                                  callback: function($$v) {
                                    _vm.$set(_vm.gpcSession, "next_step", $$v)
                                  },
                                  expression: "gpcSession.next_step"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.saving
                    ? _c(
                        "b-row",
                        { staticClass: "text-center" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "spinner", size: "lg", spin: "" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      ref: "gpcInputMessage",
                      attrs: { show: !!_vm.message, variant: "success" }
                    },
                    [_vm._v(_vm._s(_vm.message))]
                  ),
                  _vm._v(" "),
                  !_vm.saving
                    ? _c(
                        "b-row",
                        { staticClass: "pb-5" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    variant: "success",
                                    disabled: !_vm.formCompleted
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.save()
                                    }
                                  }
                                },
                                [_vm._v("Save")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !!_vm.message
                            ? _c(
                                "b-col",
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function($event) {
                                          _vm.clearForm()
                                        }
                                      }
                                    },
                                    [_vm._v("Add another")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "default" },
                                  on: {
                                    click: function($event) {
                                      _vm.clearForm()
                                    }
                                  }
                                },
                                [_vm._v("Clear Form")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cc11f52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cc11f52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GPCAdd.vue
// module id = null
// module chunks = 